module.exports = __webpack_public_path__ + "static/img/product01_04.4b7abc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product01/product01_04.jpg
// module id = XkDC
// module chunks = 1